import { render, staticRenderFns } from "./ModalAuxiliar.vue?vue&type=template&id=fee3b140&"
import script from "./ModalAuxiliar.vue?vue&type=script&lang=js&"
export * from "./ModalAuxiliar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports